import { StyleSheet } from 'aphrodite';
import { titles } from '../../../../web/styles/colors';

export const s = StyleSheet.create({
	accountSwitcherTrigger: {
		fontWeight: 400,
		color: titles,
		fontSize: 'inherit',
		fontFamily: 'inherit',
		background: 'none',
		border: 'none',
		padding: 0,
		cursor: 'pointer',
	},
	comboboxContent: {
		width: 360,
	},
});
